import { computed, makeObservable } from 'mobx'
import { MessageContentViewModel } from '../../../MessageViewModel'
import Message from 'messaging/models/Message'
import { CallContent } from 'messaging/models/Content'
import { Id } from 'types/definitions'

/**
 * Call content.
 */
export class CallMessageContentViewModel implements MessageContentViewModel {
  constructor(
    public message: Message,
    private fetchCall: (callId: Id) => Promise<void>
  ) {
    makeObservable(this)
  }

  @computed
  get call() {
    const content = this.message.content as CallContent
    return content.call
  }

  async activate(): Promise<void> {
    await this.fetchCall(this.call.id)
  }
}
